"use client";

import Image from "next/image";
import React from "react";
import { useRouter } from "next/navigation";

const TagItem: React.FC<any> = ({ tag }) => {
  const router = useRouter();

  const handleClick = () => {
    router.push(
      `/blog?tag=${encodeURIComponent(tag.slug || tag.name.toLowerCase())}`
    );
  };

  return (
    <span
      onClick={handleClick}
      key={tag.id}
      className="cursor-pointer inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full whitespace-nowrap"
      style={{
        color: tag.color.text,
        backgroundColor: tag.color.background,
      }}
    >
      {tag.icon && (
        <Image
          src={tag.icon[0].url}
          alt={tag.name}
          width={18}
          height={18}
          className="w-4 h-4 shrink-0"
        />
      )}
      {tag.name}
    </span>
  );
};

export default TagItem;
